import {
    EcmsPortal,
    EcmsPortalsResponse,
    EcmsResponse,
} from '~/adapters/services/accounts/tax-exemptions-ECMS-old/types';
import { ApiCall } from '~/adapters/services/shared/apiCall';
import { useAccountsApiCall } from '~/adapters/services/accounts/accountsApiCall';
import { useMemo } from 'react';

class TaxExemptionsRepository {
    constructor(private readonly accountsApiCall: ApiCall) {}

    public getTaxExemptionsInfo = async (accountId: number): Promise<EcmsResponse> => {
        const response = await this.accountsApiCall<EcmsResponse>(`/accounts/${accountId}/tax-exemptions`);
        return response.data;
    };

    public createTaxExemptionPortal = async (accountId: number, email: string): Promise<EcmsPortal> => {
        const response = await this.accountsApiCall<EcmsPortal>(`/accounts/${accountId}/tax-exemptions/portals`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { email },
        });

        return response.data;
    };

    public getTaxExemptionPortal = async (accountId: number): Promise<EcmsPortal | null> => {
        const { data: responseData } = await this.accountsApiCall<EcmsPortalsResponse>(
            `/accounts/${accountId}/tax-exemptions/portals`,
        );

        return responseData.portals.length ? responseData.portals[0] : null;
    };
}

export const useTaxExemptionsRepository = () => {
    const accountsApiCall = useAccountsApiCall();

    return useMemo(() => new TaxExemptionsRepository(accountsApiCall), []);
};
